export * from './TextatorLogo';
